import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuickOrderItem } from '@order/models/quick-order-entry-view-model';
import {
  QuickOrderEntryInputTypeEnum,
  QuickOrderEntryToggleButtonEnum,
} from '@order/pages/quick-order-entry/constants/quick-order-entry.constants';
import { ProductPropertiesEnum } from '@usf/product-types';

@Component({
  template: '',
})
export class QuickOrderEntryBaseComponent {
  public readonly INPUT_TYPE_PRODUCT_NUMBER =
    QuickOrderEntryInputTypeEnum.INPUT_TYPE_PRODUCT_NUMBER;
  public readonly INPUT_TYPE_CASES =
    QuickOrderEntryInputTypeEnum.INPUT_TYPE_CASES;
  public readonly INPUT_TYPE_EACHES =
    QuickOrderEntryInputTypeEnum.INPUT_TYPE_EACHES;
  public readonly propertiesEnum = ProductPropertiesEnum;
  public readonly TOGGLE_BTN_PRODUCT_NUMBER =
    QuickOrderEntryToggleButtonEnum.TOGGLE_BTN_PRODUCT_NUMBER;
  public readonly TOGGLE_BTN_CUST_NUMBER =
    QuickOrderEntryToggleButtonEnum.TOGGLE_BTN_CUST_NUMBER;

  quickOrderItem: QuickOrderItem;
  @Input() set qoi(item: QuickOrderItem) {
    this.quickOrderItem = JSON.parse(JSON.stringify(item));
  }
  @Input() isOnline: boolean;
  @Input() toggleSelection: string;
  @Output()
  search: EventEmitter<QuickOrderItem> = new EventEmitter<QuickOrderItem>();
  @Output()
  quantity: EventEmitter<QuickOrderItem> = new EventEmitter<QuickOrderItem>();
  @Output()
  hotkey: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  forceFocus: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  pasteFired(event: any): void {
    event.stopPropagation();
    event.preventDefault();
    const current: string = event?.target?.nativeElement?.value || '';
    const cursorPos = event?.target?.selectionStart;
    const pasteText = event?.clipboardData?.getData('text') as string;

    if (this.toggleSelection === this.TOGGLE_BTN_PRODUCT_NUMBER) {
      const numericOnly = pasteText.replace(/[^0-9]/g, '');
      const numStr: string = (
        current.slice(0, cursorPos) +
        numericOnly +
        current.slice(cursorPos)
      )?.substring(0, 7);

      const productNumber = !!numStr ? Number(numStr) : undefined;
      if (this.quickOrderItem.productNumber != productNumber) {
        this.quickOrderItem.casesOrdered.previousValue = 0;
        this.quickOrderItem.eachesOrdered.previousValue = 0;
        this.quickOrderItem.productNumber = productNumber;
        this.search.emit(this.quickOrderItem);
      }
    } else if (this.toggleSelection === this.TOGGLE_BTN_CUST_NUMBER) {
      const customerProductNumber = pasteText?.substring(0, 9);
      if (this.quickOrderItem.customerProductNumber != customerProductNumber) {
        this.quickOrderItem.casesOrdered.previousValue = 0;
        this.quickOrderItem.eachesOrdered.previousValue = 0;
        this.quickOrderItem.customerProductNumber = customerProductNumber;
        this.search.emit(this.quickOrderItem);
      }
    }
    this.hotkey.emit(event);
  }

  onlyNumbers(event: any, type: string): void {
    event.stopPropagation();
    event.preventDefault();
    const customerProductNumber = event?.target?.value?.trim()?.substring(0, 9);
    const numStr = customerProductNumber
      ?.replace(/[^0-9]/g, '')
      ?.substring(0, 7);

    switch (type) {
      case this.INPUT_TYPE_PRODUCT_NUMBER:
        if (this.toggleSelection === this.TOGGLE_BTN_PRODUCT_NUMBER) {
          this.quickOrderItem.productNumber = !!numStr
            ? Number(numStr)
            : undefined;
        } else if (this.toggleSelection === this.TOGGLE_BTN_CUST_NUMBER) {
          this.quickOrderItem.customerProductNumber = !!customerProductNumber
            ? customerProductNumber
            : undefined;
        }
        break;
      case this.INPUT_TYPE_CASES:
        this.quickOrderItem.casesOrdered.currentValue = !!numStr
          ? Number(numStr)
          : undefined;
        break;
      case this.INPUT_TYPE_EACHES:
        this.quickOrderItem.eachesOrdered.currentValue = !!numStr
          ? Number(numStr)
          : undefined;
        break;
    }
    if (
      (this.toggleSelection === this.TOGGLE_BTN_PRODUCT_NUMBER &&
        (isNaN(this.quickOrderItem.productNumber) ||
          this.quickOrderItem.productNumber < 0)) ||
      (this.toggleSelection === this.TOGGLE_BTN_CUST_NUMBER &&
        !this.quickOrderItem.customerProductNumber)
    ) {
      this.quickOrderItem.productNumber = undefined;
      this.quickOrderItem.customerProductNumber = undefined;
      this.quickOrderItem.casesOrdered.previousValue = 0;
      this.quickOrderItem.eachesOrdered.previousValue = 0;
    }
  }

  productNumberUpdate(event: any): void {
    event.stopPropagation();
    event.preventDefault();
    this.search.emit(this.quickOrderItem);
    this.hotkey.emit(event);
  }

  quantityUpdate(event: any): void {
    event.stopPropagation();
    event.preventDefault();
    this.quantity.emit(this.quickOrderItem);
    this.hotkey.emit(event);
  }
}
